/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupV2ListItem
 */
export interface MarkupV2ListItem {
    /**
     * 
     * @type {string}
     * @memberof MarkupV2ListItem
     */
    id?: string;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof MarkupV2ListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof MarkupV2ListItem
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof MarkupV2ListItem
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2ListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2ListItem
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2ListItem
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2ListItem
     */
    relevance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2ListItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2ListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2ListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2ListItem
     */
    allowEdit?: boolean;
}

export function MarkupV2ListItemFromJSON(json: any): MarkupV2ListItem {
    return MarkupV2ListItemFromJSONTyped(json, false);
}

export function MarkupV2ListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2ListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function MarkupV2ListItemToJSON(value?: MarkupV2ListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'description': value.description,
        'comment': value.comment,
        'value': value.value,
        'relevance': value.relevance,
        'enabled': value.enabled,
        'deleted': value.deleted,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
    };
}


